import * as z from "zod";
import { gql } from "graphql-request";
import { Image, ImageFragment } from "../image";
import { Sys, SysFragment } from "../sys";
import { CountdownTimer, CountdownTimerFragment } from "../countdownTimer";
import { UnifiedButton, UnifiedButtonFragment } from "../unifiedButton";

export const CarouselEventEntrySchema = z.object({
  __typename: z.literal("CarouselEventEntry"),
  sys: Sys,
  entryTitle: z.string().nullable(),
  entryHideTitle: z.boolean().nullable(),
  carouselImage: Image.nullable(),
  carouselImageEn: Image.nullable(),
  ctaButtonsCollection: z
    .object({
      items: z.array(UnifiedButton).nullish(),
    })
    .nullish(),
  countdownTimer: CountdownTimer.nullish(),
});

export const CarouselEventEntry = CarouselEventEntrySchema;
export type CarouselEventEntry = z.infer<typeof CarouselEventEntrySchema>;

export const CarouselEventEntryFragment = gql`
  fragment CarouselEventEntryFragment on CarouselEventEntry {
    __typename
    sys {
      ...SysFragment
    }

    entryTitle
    entryHideTitle
    carouselImage {
      ...ImageFragment
    }
    carouselImageEn: carouselImage(locale: "en") {
      ...ImageFragment
    }

    ctaButtonsCollection {
      items {
        __typename
        ... on UnifiedButton {
          ...UnifiedButtonFragment
        }
      }
    }

    countdownTimer {
      ...CountdownTimerFragment
    }
  }

  ${SysFragment}
  ${ImageFragment}
  ${UnifiedButtonFragment}
  ${CountdownTimerFragment}
`;
